define('views/blocks/CartVoucherView',['jquery',
        'underscore',
        'backbone',
        'app',
        'router',
        'SubView',
        'views/blocks/FreeProductChoiceVoucherView',
        'views/blocks/checkout/VoucherCheckoutDialogView',
        'template!blocks/cart/voucher',
        'template!blocks/cart/voucher-item',
        'InternalLinkView', 'hooks'
       ],
    function ($,
              _,
              Backbone,
              app,
              router,
              SubView,
              FreeProductChoiceVoucherView,
              VoucherCheckoutDialogView,
              voucherTemplate,
              voucherItemTemplate,
              InternalLinkView,hooks
              ) {

        //
        // représente le bloc bon de réduction
        //

        return Backbone.View.extend(SubView).extend({

            events: {
                'click .btn-voucher': 'openVoucher',
                'click .btn-voucher--checkout': 'openVoucherCheckout',
                'submit .voucher-form': 'sendVoucher',
                'click ul .voucher-delete': 'deleteVoucher',
                'click .voucher-icon, .voucher-name': 'infoVoucher',
                'click .sponsorship .btn-delete ': 'deleteSponsorShip',

                'click ul li': 'voucherAction',
                'focusout .voucher-input': 'focusOutField',
                'keyup .voucher-input': 'keyInput',
                'blur .voucher-input': 'keyInput'
            },

            initialize: function (options) {
                var view = this,
                    cart = view.cart = options.cart ? options.cart : app.getCart();
                view.checkout = !!options.checkout;
                view.subviews = [];
                view.listenTo(cart, 'change:discounts', view.onChangeDiscounts);
                view.render();
            },
            focusOutField:function(e){
                var view = this, relatedTarget = e.relatedTarget;
                if(_.isNull(relatedTarget) || !view.$(relatedTarget).is('.btn-classic')){
                    view.$('.voucher').removeClass('active');
                }
            },
            sendVoucher:function (e) {
                e.preventDefault();
                var view = this,
                    input = view.$('.voucher input[type=text]'),
                    btn = view.$('.btn-classic');
                var voucherCode = input.val();

                function ButtonLoader(init){
                    btn.prop('disabled',init===true).toggleClass('loading',init===true);
                }

                ButtonLoader(true);
                app.getCart().addVoucher(voucherCode)
                    .done(function(){
                        ButtonLoader();
                        input.val('');
                    })
                    .fail(ButtonLoader);

            },
            openVoucher: function(e){
                var view = this,
                    container = $(e.currentTarget).parent();
                var message = app.t('merci de vous connecter pour pouvoir utiliser votre bon de réduction','Checkout');
                app.getCart().requireAuthentification(function(success){
                    // require authentication
                    if(success){
                        if(view.checkout && app.isMobile()){
                            return view.openVoucherCheckout();
                        }
                        container.addClass('active');
                        container.find('input').trigger('focus');
                    }
                },message)

            },
            openVoucherCheckout:function(){
                new VoucherCheckoutDialogView();
            },
            voucherAction:function(e){
                var view = this,
                    cart = app.getCart(),
                    id_cart_discount = $(e.currentTarget).data('id').toString(),
                    discount = cart.getVoucher().findWhere({id_cart_discount:id_cart_discount});

                if(discount){
                    if(discount.force_cart_apear == 1){
                        var modalView = new FreeProductChoiceVoucherView({
                            voucher:discount
                        });
                        app.displayModal(modalView);
                    }
                }
            },
            deleteVoucher: function(e)
            {
                var currentTarget = e.currentTarget,
                    id_cart_discount = $(currentTarget).parents('.voucher-code').data('id');
                currentTarget.disabled = true;
                app.getCart().removeVoucher(id_cart_discount);
            },
            infoVoucher: function(e)
            {
                var currentTarget = e.currentTarget,
                    id_cart_discount = $(currentTarget).parents('.voucher-code').data('id'),
                    discount = app.getCart().getVoucher().findWhere({id_cart_discount:''+id_cart_discount});
                if(discount){
                    app.alert({
                        title:app.t('Code promo','Cart')+' '+discount.name,
                        subtitle:discount.description,
                    })
                }
            },
            keyInput:function(e){
                var currentTarget = e.currentTarget;
                if(e.keyCode === 27){
                    document.activeElement.blur();
                }
                this.updateFilledState(currentTarget.value.length!=0);
            },

            updateFilledState:function(filled){
                this.$('.voucher-form').toggleClass('filled',filled);
            },

            render: function () {

                var view = this,
                    cart = view.cart,
                    vouchers = cart.getVoucher(),
                    t = voucherTemplate({
                        vouchers:vouchers,
                        checkout:view.checkout,
                    });

                vouchers.some(function(v)
                 {
                     if (v.invalid == 1){
                        app.banNotice(app.t('Un ou plusieurs bons de réductions présents dans votre panier ne sont pas disponibles', 'Cart'));
                        return true;
                     }
                 });

                view.$el.html(t);
                InternalLinkView.initializeLinksOfView(this);
                view.delegateEvents();
            },
            onChangeDiscounts:function(cart,discounts){
                var view = this, existsClass = 'exists';
                view.$('.voucher-code').removeClass(existsClass);
                view.$('.voucher.inline-button-input').attr('data-count',discounts.length);
                _(discounts).each(function(voucher){
                    var existsEl = view.$('.voucher-code[data-id='+voucher.id_cart_discount+']');
                    if(existsEl.length){
                        existsEl.addClass(existsClass);
                    }else{
                        existsEl = $(voucherItemTemplate(voucher));
                        existsEl.addClass(existsClass);
                        view.$('.voucher-list').append(existsEl);
                    }
                });
                view.$('.voucher-code:not(.'+existsClass+')').remove();
                view.delegateEvents();

            }


        });
    });
